export default __webpack_public_path__ + "static/media/icon_denied.8561e754.svg";